module.exports = __webpack_public_path__ + "static/media/team-falera.b33edf71.jpg";